import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { wfApi } from '../../api/workflow.js';

export default function ResourceRedirect() {
  const { resourceType, resourceId } = useParams();
  const [resolved, setResolved] = useState(null); // null = loading, '' = not found, '/path' = redirect

  useEffect(() => {
    wfApi
      .getStatusForResource(resourceType, resourceId)
      .then((d) => setResolved(d?.instance?.id ? `/workflows/instances/${d.instance.id}` : ''))
      .catch(() => setResolved(''));
  }, [resourceType, resourceId]);

  if (resolved === null) return <div className="muted">Locating workflow…</div>;
  if (resolved === '') return <Navigate to="/workflows/instances" replace />;
  return <Navigate to={resolved} replace />;
}
